import { useState } from 'react'
import sendIcon from '../assets/pictures/send.svg'

export default function ChatInput({ onSend, disabled, hasStarted }) {
  const [value, setValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (disabled) return
    const trimmed = value.trim()
    if (!trimmed) return
    onSend(trimmed)
    setValue('')
  }

  // Hidden while the user is actively typing, and permanently once the
  // chat has started — otherwise it reappears when the input loses focus.
  const hideDisclaimer = isFocused || hasStarted

  return (
    <form className="allie-chat-input-form" onSubmit={handleSubmit}>
      <div className="allie-chat-input-wrap">
        <input
          type="text"
          className="allie-chat-input"
          placeholder="Type your message..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          enterKeyHint="send"
          disabled={disabled}
        />
        <button
          type="submit"
          className="allie-send-btn"
          aria-label="Send message"
          disabled={disabled}
        >
          <img src={sendIcon} alt="" width="24" height="24" />
        </button>
      </div>
      {!hideDisclaimer && (
        <p className="allie-footer-disclaimer">
          Like all of us, Allie is always learning and may produce inaccurate
          information. Please consult your care team for all medical advice.
        </p>
      )}
    </form>
  )
}
